exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.path[data-v-4dc01500] {\n  padding: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.path .path-field[data-v-4dc01500] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.path .actions[data-v-4dc01500] {\n  padding-top: 6px;\n  width: 124px;\n}\n.path .actions button[data-v-4dc01500] {\n  margin-left: 2px;\n}\n", ""]);

// exports
